import React, { useMemo } from 'react';

import { useAppSelector } from 'utils/hooks';

import Button from 'components/shared/Button';
import Slider from 'components/shared/Slider';

import crops from 'domains/crops';

type ImageToolsProps = {
  handleZoom: (value: string) => void;
  handleRotateImage: () => void;
  handleShowImageFilters: () => void;
};

function ImageTools(props: ImageToolsProps) {
  const { handleZoom, handleRotateImage, handleShowImageFilters } = props;

  const activeCrop = useAppSelector(crops.selectors.activeCrop);

  const zoom = useMemo(() => (!!activeCrop && activeCrop.zoom) || '1', [activeCrop]);

  return (
    <div className="image-tools">
      <Button
        type="icon"
        icon="redo"
        appearance="themed"
        a11yText="Rotate Image"
        onClick={handleRotateImage}
        size="lg"
      />

      <Slider
        id="crop-zoom"
        min="1"
        max="2"
        step="0.01"
        onChange={handleZoom}
        title="Zoom Image"
        value={zoom}
      />

      <Button
        type="icon"
        icon="wand-magic-sparkles"
        appearance="themed"
        a11yText="Add Filter"
        onClick={handleShowImageFilters}
        size="lg"
      />
    </div>
  );
}

export default ImageTools;
